import { AssistChip, Stack, Text } from '@sixui/ui';
import stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';

import type { IApiGetOrganizationUserResponseBody } from '~/lib/api/modules/Organizations';
import { UserAvatar } from '~/components/atoms/UserAvatar';
import { Table } from '~/components/molecules/Table';
import { getOrganizationRoleLabel } from '~/components/organisms/fields/OrganizationRoleSelector';
import { parseUserInfo } from '~/helpers/parseUserInfo';
import { useAuthUser } from '~/lib/auth';

export type IAppOrganizationUserListItemProps = {
  organizationId: string;
  user: IApiGetOrganizationUserResponseBody;
};

const styles = stylex.create({
  me: {
    fontWeight: 'bold',
  },
});

export const AppOrganizationUserListItem: React.FC<
  IAppOrganizationUserListItemProps
> = (props) => {
  const { user } = props;
  const { t } = useTranslation();
  const userInfo = parseUserInfo(user);
  const { fullName, emailAddress } = userInfo;
  const authUser = useAuthUser();
  const isMe = authUser?._id === user._id;

  return (
    <Table.Row>
      <Stack as={Table.Body} horizontal gap={3} sx={isMe && styles.me}>
        <UserAvatar user={user} />
        <Stack gap={1}>
          <Text variant="title" size="sm" truncate>
            {fullName}
            {isMe ? ` (${t('common.you')})` : null}
          </Text>
          <Text variant="body" size="sm" dimmed>
            {emailAddress}
          </Text>
        </Stack>
      </Stack>
      <Stack as={Table.Body} horizontal gap={2}>
        {user.roles?.map((role, roleIndex) => (
          <AssistChip
            key={roleIndex}
            label={getOrganizationRoleLabel(role, t) ?? role}
          />
        ))}
      </Stack>
      <Stack as={Table.Body} horizontal justify="end" />
    </Table.Row>
  );
};
